import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core'
import { NgClass } from '@angular/common'
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms'

@Component({
  selector: 'app-number-stepper',
  standalone: true,
    imports: [
        NgClass,
        FormsModule
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => NumberStepperComponent),
            multi: true
        }
    ],
  templateUrl: './number-stepper.component.html',
  styleUrl: './number-stepper.component.scss'
})
export class NumberStepperComponent implements ControlValueAccessor, OnInit, OnChanges {
    @Input() size: 'small' | 'regular' = 'regular'
    @Input() min: number = 1;
    @Input() max?: number;
    @Input() disabled: boolean = false
    @Input() fullWidth: boolean = true

    @Input() value: number = this.min
    @Output() valueChange: EventEmitter<number> = new EventEmitter<number>()

    constructor(private changeRef: ChangeDetectorRef) {
    }

    // ControlValueAccessor hooks
    private onChange: (value: number) => void = () => {
    }
    private onTouched: () => void = () => {
    }

    writeValue(value: number): void {
        this.value = value
    }

    registerOnChange(fn: (value: number) => void): void {
        this.onChange = fn
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled
    }


    ngOnInit() {
        if(this.min === this.max){
            this.disabled = true;
        }
        if(this.min === 0 && this.max === 0){
            this.onValueChange(0)
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes['min'] || changes['max']){
            if(this.min === 0 && this.max === 0){
                this.onValueChange(0)
            } else {
                this.onValueChange(this.clampValue(this.value))
            }
        }
    }

    private clampValue(value: number){
        if((this.max || this.max === 0) && value > this.max){
            return this.max
        } else if(value < this.min){
            return this.min
        } else {
            return value
        }
    }


    // Internal change handler to sync both outputs
    private emitValue(value: number): void {
        this.onChange(value)
        this.valueChange.emit(value)
    }

    onValueChange(value?: number) {
        if(!value && value !== 0){
            return
        }
        if((this.max || this.max === 0) && value > this.max){
            this.value = this.max - 1
            this.changeRef.detectChanges()
            this.value = this.max
        } else if(value < this.min){
            this.value = this.min + 1
            this.changeRef.detectChanges()
            this.value = this.min
        } else {
            this.value = value
        }

        this.emitValue(this.value);
    }

    add(){
        this.onValueChange((this.max || this.max === 0) ? Math.min(this.value + 1, this.max) : this.value + 1)
    }

    remove(){
        this.onValueChange(Math.max(this.value - 1, this.min))
    }
}
